import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import iosDownloadButton from '../../../../images/buttons/ios_download_button.svg';
import androidDownloadButton from '../../../../images/buttons/android_download_button.svg';

function TracksolidSuccessScreen() {
  const { t } = useTranslation('activation_wizard');

  return (
    <div>
      <h2>{t('success_screen.title')}</h2>
      <p>{t('success_screen.tracksolid.instruction_1')}</p>
      <p>
        <Trans i18nKey="activation_wizard:success_screen.tracksolid.instruction_2">
          Click <a
            href="https://www.tracksolid.com"
            rel="noreferrer noopener"
            target="_blank">here</a>
            for the web app or use the links below to access the iOS and Android apps.
        </Trans>
      </p>
      <div className="appStoreDownloads">
        <a
          href="http://itunes.apple.com/us/app/id1070068294"
          rel="noreferrer noopener"
          target="_blank">
          <img src={iosDownloadButton} className="appStoreButton" />
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=com.jimi.tuqiang.tracksolid"
          rel="noreferrer noopener"
          target="_blank">
          <img src={androidDownloadButton} className="appStoreButton" />
        </a>
      </div>
    </div>
  );
}

function ShieldGPSSuccessScreen() {
  const { t } = useTranslation('activation_wizard');

  return (
    <div>
      <h2>{t('success_screen.title')}</h2>
      <p>{t('success_screen.shieldgps.instruction_1')}</p>
      <p>
        <Trans i18nKey="activation_wizard:success_screen.shieldgps.instruction_2">
          Click <a
            href="/dashboard"
            rel="noreferrer noopener"
            target="_blank">here</a>
            for the web app or use the links below to access the iOS and Android apps.
        </Trans>
      </p>
      <div className="appStoreDownloads">
        <a
          href="/wt/shieldgps-app-ios"
          rel="noreferrer noopener"
          target="_blank">
          <img src={iosDownloadButton} className="appStoreButton" />
        </a>
        <a
          href="/wt/shieldgps-app-android"
          rel="noreferrer noopener"
          target="_blank">
          <img src={androidDownloadButton} className="appStoreButton" />
        </a>
      </div>
    </div>
  );
}

function SuccessScreen(props) {
  if (props.devicePlatform === 'tracksolid') {
    return <TracksolidSuccessScreen />;
  }

  return <ShieldGPSSuccessScreen />;
}

export default SuccessScreen;
